import { render, staticRenderFns } from "./EditOrder.vue?vue&type=template&id=2036f382&scoped=true"
import script from "./EditOrder.vue?vue&type=script&lang=js"
export * from "./EditOrder.vue?vue&type=script&lang=js"
import style0 from "./EditOrder.vue?vue&type=style&index=0&id=2036f382&prod&lang=scss&scoped=true"
import style1 from "./EditOrder.vue?vue&type=style&index=1&id=2036f382&prod&lang=scss"
import style2 from "./EditOrder.vue?vue&type=style&index=2&id=2036f382&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2036f382",
  null
  
)

export default component.exports